import { z } from 'zod'

/**
 * GoHighLevel's status of a calendar appointment. Mirrors the
 * `GhlAppointmentStatus` enum in the Prisma schema (`check:enums`).
 *
 * Kept for lead stats (docs/gohighlevel-stats.spec.md): a number can count the
 * appointments on chosen calendars with chosen statuses, such as open house RSVPs.
 * Whether anyone marks `showed` or `noshow` is up to each company, so nothing
 * here assumes they do.
 */
export const GHL_APPOINTMENT_STATUSES = [
  'new',
  'confirmed',
  'cancelled',
  'showed',
  'noshow',
  'invalid',
] as const

export const ghlAppointmentStatusSchema = z.enum(GHL_APPOINTMENT_STATUSES)

export type GhlAppointmentStatus = z.infer<typeof ghlAppointmentStatusSchema>

/** How each status is labeled in the app: American spelling, GHL's meaning. */
export const GHL_APPOINTMENT_STATUS_LABEL: Record<
  GhlAppointmentStatus,
  string
> = {
  new: 'New',
  confirmed: 'Confirmed',
  cancelled: 'Canceled',
  showed: 'Showed',
  noshow: 'No-show',
  invalid: 'Invalid',
}
